"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProductId = createProductId;
exports.createCustomerId = createCustomerId;
exports.createOrderId = createOrderId;
exports.createPrice = createPrice;
exports.createCategoryId = createCategoryId;
function createProductId(id) {
    return id;
}
function createCustomerId(id) {
    return id;
}
function createOrderId(id) {
    return id;
}
function createPrice(amount) {
    return amount;
}
function createCategoryId(id) {
    return id;
}
//# sourceMappingURL=brands.js.map